/**
 * Interface para opciones individuales de la ruleta
 * Define las propiedades de cada sector/opción de la ruleta
 */
export interface WheelOption {
  key: string;
  label: string;
  value: string;
  color: string;
  textColor: string;
  bonus_type: string;
  bonusTag?: string;
  id: string;
  tag?: string;
}

/**
 * Interface para configuración de ruleta pendiente
 * Utilizada para transferir configuración entre componentes
 */
export interface PendingRouletteConfig {
  enabled: boolean;
  wheelOptions: WheelOption[] | string;
  wheelCampaign?: string; // Identificador de la campaña
  timestamp: number;
  source?: string;
  linkLegalTerms?: string; // URL personalizada de términos y condiciones
}

/**
 * Interface para el resultado de girar la ruleta
 * Contiene la información del premio obtenido
 */
export interface RouletteResult {
  winner: WheelOption;
  winnerIndex: number;
  timestamp: number;
  isValid: boolean;
}

/**
 * Interface para configuración general de ruleta en componentes
 * Define el comportamiento de la ruleta en el componente
 */
export interface RouletteConfig {
  enabled: boolean;
  showOnSuccess: boolean;
  autoRedirect?: boolean;
}

/**
 * Interface para estado de la ruleta
 * Maneja el estado interno de la ruleta durante su funcionamiento
 */
export interface RouletteState {
  isSpinning: boolean;
  hasResult: boolean;
  currentResult: RouletteResult | null;
  isInitialized: boolean;
}

/**
 * Interface para rangos de montos y probabilidades de premios
 * Define qué premios están disponibles según el monto simulado
 */
export interface AmountRange {
  min: number;
  max: number;
  eligiblePrizeTypes: PrizeType[];
}

/**
 * Tipos base de premios disponibles en la ruleta
 */
export enum PrizeType {
  MEJOR_TASA = 'mejor_tasa',
  BONO_1M = 'bono_1M',
  BONO_100K = 'bono_100K',
  BONO_50K = 'bono_50K',
  BONO_20K = 'bono_20K',
  BONIFICACION_020 = 'bonificacion_020',
  BONIFICACION_040 = 'bonificacion_040',
  BONIFICACION_060 = 'bonificacion_060',
  SIGUE_PARTICIPANDO = 'sigue_participando',
}

/**
 * Interface para configuración de generación dinámica de premios
 */
export interface DynamicPrizeConfig {
  amountRanges: AmountRange[];
  baseProbabilities: Record<PrizeType, number>;
  minOptions: number;
  maxOptions: number;
}

/**
 * Interface para template de creación de WheelOption por tipo de premio
 */
export interface PrizeTemplate {
  type: PrizeType;
  label: string;
  color: string;
  textColor: string;
  bonus_type: string;
  value: string;
  bonusTag?: string;
  tag?: string;
}
